import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import classnames from "classnames";
import Component, { type CountdownTimersComponentProps } from "./component";
import { makeCountdownOptionsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const countdownOptionsSelector = makeCountdownOptionsSelector();

  const elementVisibilitySelector = getSettingValueSelector(TargetSelector.Entity, "elementVisibility");

  return (state: AppState, props: RootContainerProps): CountdownTimersComponentProps => {
    const elementVisibility = elementVisibilitySelector(state, props);
    const countdownOptions = countdownOptionsSelector(state, props);
    return {
      ...props,
      className: classnames("countdown", elementVisibility.split(",")),
      countdownOptions
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
